/* eslint-disable react/require-default-props */
function Instagram({
  color = '#6B7280',
  backgroundColor = '#fff',
  height = '24',
  width = '24',
}: {
  color?: string;
  backgroundColor?: string;
  height?: string;
  width?: string;
}) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_instagram)">
        <path
          d="M12 2.16094C15.2063 2.16094 15.5859 2.175 16.8469 2.23125C18.0188 2.28281 18.6516 2.47969 19.0734 2.64375C19.6313 2.85938 20.0344 3.11719 20.4516 3.53438C20.8734 3.95625 21.1266 4.35469 21.3422 4.9125C21.5063 5.33438 21.7031 5.97187 21.7547 7.13906C21.8109 8.40469 21.825 8.78438 21.825 11.9906C21.825 15.2016 21.8109 15.5813 21.7547 16.8422C21.7031 18.0141 21.5063 18.6469 21.3422 19.0688C21.1266 19.6266 20.8688 20.0297 20.4516 20.4469C20.0297 20.8688 19.6313 21.1219 19.0734 21.3375C18.6516 21.5016 18.0141 21.6984 16.8469 21.75C15.5813 21.8063 15.2016 21.8203 12 21.8203C8.79375 21.8203 8.41406 21.8063 7.15313 21.75C5.98125 21.6984 5.34844 21.5016 4.92656 21.3375C4.36875 21.1219 3.96563 20.8641 3.54844 20.4469C3.12656 20.025 2.87344 19.6266 2.65781 19.0688C2.49375 18.6469 2.29688 18.0094 2.24531 16.8422C2.18906 15.5766 2.175 15.1969 2.175 11.9906C2.175 8.77969 2.18906 8.40469 2.24531 7.13906C2.29688 5.96719 2.49375 5.33438 2.65781 4.9125C2.87344 4.35469 3.13125 3.95156 3.54844 3.53438C3.97031 3.1125 4.36875 2.85938 4.92656 2.64375C5.34844 2.47969 5.98594 2.28281 7.15313 2.23125C8.41406 2.175 8.79375 2.16094 12 2.16094ZM12 0C8.74219 0 8.33438 0.0140625 7.05469 0.0703125C5.77969 0.126563 4.90313 0.332812 4.14375 0.628125C3.35156 0.9375 2.68125 1.34531 2.01563 2.01562C1.34531 2.68125 0.9375 3.35156 0.628125 4.13906C0.332812 4.90313 0.126563 5.775 0.0703125 7.05C0.0140625 8.33437 0 8.74219 0 12C0 15.2578 0.0140625 15.6656 0.0703125 16.9453C0.126563 18.2203 0.332812 19.0969 0.628125 19.8563C0.9375 20.6484 1.34531 21.3188 2.01563 21.9844C2.68125 22.65 3.35156 23.0625 4.13906 23.3672C4.90313 23.6625 5.775 23.8687 7.05 23.925C8.32969 23.9812 8.7375 23.9953 11.9953 23.9953C15.2531 23.9953 15.6609 23.9812 16.9406 23.925C18.2156 23.8687 19.0922 23.6625 19.8516 23.3672C20.6391 23.0625 21.3094 22.65 21.975 21.9844C22.6406 21.3188 23.0531 20.6484 23.3578 19.8609C23.6531 19.0969 23.8594 18.225 23.9156 16.95C23.9719 15.6703 23.9859 15.2625 23.9859 12.0047C23.9859 8.74688 23.9719 8.33906 23.9156 7.05938C23.8594 5.78438 23.6531 4.90781 23.3578 4.14844C23.0625 3.35156 22.6547 2.68125 21.9844 2.01562C21.3188 1.35 20.6484 0.9375 19.8609 0.632812C19.0969 0.3375 18.225 0.13125 16.95 0.075C15.6656 0.0140625 15.2578 0 12 0Z"
          fill={color}
        />
        <path
          d="M12 5.83594C8.59688 5.83594 5.83594 8.59688 5.83594 12C5.83594 15.4031 8.59688 18.1641 12 18.1641C15.4031 18.1641 18.1641 15.4031 18.1641 12C18.1641 8.59688 15.4031 5.83594 12 5.83594ZM12 15.9984C9.79219 15.9984 8.00156 14.2078 8.00156 12C8.00156 9.79219 9.79219 8.00156 12 8.00156C14.2078 8.00156 15.9984 9.79219 15.9984 12C15.9984 14.2078 14.2078 15.9984 12 15.9984Z"
          fill={color}
        />
        <path
          d="M19.8469 5.59214C19.8469 6.38902 19.2 7.03121 18.4078 7.03121C17.6109 7.03121 16.9688 6.38433 16.9688 5.59214C16.9688 4.79995 17.6156 4.15308 18.4078 4.15308C19.2 4.15308 19.8469 4.80464 19.8469 5.59214Z"
          fill={color}
        />
      </g>
      <defs>
        <clipPath id="clip0_instagram">
          <rect width="24" height="24" fill={backgroundColor} />
        </clipPath>
      </defs>
    </svg>
  );
}

export default Instagram;
